import React from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, MenuItem } from 'react-aria-menubutton';
import { useT } from '~app/core/BundleProvider';

const FileMenu = ({ closeMenu, handleSelect, exitCanvas, resetModel }) => {
  const t = useT();
  const doc = useSelector(state => state.document.present);
  return (
    <Wrapper
      className="FileMenu__menu"
      onSelection={handleSelect}
      id="wrapper-menu"
      role="menu"
    >
      <Wrapper className="FileMenu__menu" onSelection={handleSelect}>
        {doc ? (
          <MenuItem
            tabIndex="0"
            className="FileMenu__submenu"
            value="save-options"
            aria-label={t('save')}
          >
            {t('save')}
          </MenuItem>
        ) : (
          <div
            className="FileMenu__menu-item FileMenu__menu-item-disabled"
            aria-label={t('save')}
          >
            {t('save')}
          </div>
        )}
      </Wrapper>
      <Wrapper className="FileMenu__menu" onSelection={() => resetModel()}>
        <MenuItem
          tabIndex="0"
          className="FileMenu__submenu"
          aria-label={t('reset')}
        >
          {t('reset')}
        </MenuItem>
      </Wrapper>
      <Wrapper className="FileMenu__menu" onSelection={() => exitCanvas()}>
        <MenuItem
          tabIndex="0"
          className="FileMenu__submenu"
          aria-label={t('home')}
        >
          {t('home')}
        </MenuItem>
      </Wrapper>
      <Wrapper
        className="FileMenu__menu"
        onSelection={() => closeMenu('wrapper-menu')}
      >
        <MenuItem
          tabIndex="0"
          className="FileMenu__close-icon"
          aria-label={t('close-menu')}
        >
          &#10006;
        </MenuItem>
      </Wrapper>
    </Wrapper>
  );
};

export default FileMenu;
